/**
 * Shared UI theme constants.
 * Centralises form styles, colors, and spacing that were previously
 * copy-pasted across 6+ page files.
 */

// ── Form input styles ────────────────────────────────────────────────────────

/** Standard form input (text, select, textarea base) */
export const F = {
  width: "100%", padding: "11px 13px", background: "#0f1623",
  border: "1px solid #1e2d45", borderRadius: 9, color: "#e2e8f0",
  fontSize: 14, fontFamily: "inherit", outline: "none",
};

/** Standard label (uppercase, small, muted) */
export const L = {
  display: "block", fontSize: 10, fontWeight: 700, letterSpacing: "0.1em",
  textTransform: "uppercase", color: "#64748b", marginBottom: 6,
};

// ── Sentiment colors ─────────────────────────────────────────────────────────

export const SENTIMENT_COLORS = {
  positive: "#22c55e",
  neutral: "#f59e0b",
  negative: "#ef4444",
};

/** Get sentiment color by key, with fallback to neutral */
export function sentimentColor(sentiment) {
  return SENTIMENT_COLORS[sentiment] || SENTIMENT_COLORS.neutral;
}

// ── Background / surface tokens ──────────────────────────────────────────────

export const COLORS = {
  bg: "#060a13",
  surface: "#0c1220",
  surfaceHover: "#0f1623",
  border: "#1e2d45",
  borderLight: "#2d3f5a",
  text: "#f1f5f9",
  textMuted: "#94a3b8",
  textDim: "#64748b",
  accent: "#3b82f6",
  accentDim: "#60a5fa",
  success: "#22c55e",
  warning: "#f59e0b",
  error: "#ef4444",
  partyDefault: "#3b82f6",
};

// ── Common component styles ──────────────────────────────────────────────────

/** Card container */
export const CARD = {
  background: "#0c1220",
  border: "1px solid #1e2d45",
  borderRadius: 11,
  padding: "18px 16px",
};

/** Pill button (filter tabs, tag pills) */
export const PILL = {
  padding: "6px 14px",
  borderRadius: 20,
  border: "1px solid #1e2d45",
  background: "transparent",
  color: "#94a3b8",
  fontSize: 12,
  fontWeight: 500,
  cursor: "pointer",
  fontFamily: "inherit",
};

/** Active pill variant */
export const PILL_ACTIVE = {
  ...PILL,
  background: "#1e3a5f",
  borderColor: "#3b82f640",
  color: "#60a5fa",
  fontWeight: 700,
};
